import base from '@/http/url_base';

export default {
  TIERS: base.API + '/tiers',
  CLIENTS_PROSPECTS: base.API + '/clients-prospects',
  GET_REQUIREMENTS: base.API + '/tiers/requirements',
  //SEARCH_TIERS: base.API + '/tiers/search',
  CONTACT: base.API + '/tiers-contacts',
  RESEAU: base.API + '/tiers-connaissances',
  NOTE: base.API + '/tiers-notes',
  BANQUE: base.API + '/tiers-banques',
  TIERS_PARAM: base.API + '/tiers-params',
  TIERS_PARAM_REQUIREMENTS: base.API + '/tiers-params/requirements',
  SEARCH_CLIENT_PROSPECT: base.API + '/clients-prospects/search',
};
